import React, { useState } from "react";
import validationsAddSiteUserAdvertiser from "../../../validtions/forms/site-user-advertiser/add";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";

export default function AddSiteUserAdvertiser({ getAllSiteUserAdvertiser }) {
  const [showInput, setShowInput] = useState(false);
  const [message, setMessage] = useState();

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const scrollForSeeMessage = () => {
    const element = document.querySelector(
      ".container-all-site-user-advertiser"
    );
    element.scrollIntoView();
  };

  const sendFrom = async () => {
    const websiteUrl = document.querySelector("#website-url").value;
    const resValidationsAddSiteUserAdvertiser =
      validationsAddSiteUserAdvertiser(websiteUrl);

    if (!resValidationsAddSiteUserAdvertiser.status) {
      setMessage({
        type_class: "alert alert-danger",
        text: resValidationsAddSiteUserAdvertiser.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddSiteAdvertiser =
      await sendRequestAddSiteAdvertiser({
        url: websiteUrl,
      });
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestAddSiteAdvertiser) {
      return;
    }

    await getAllSiteUserAdvertiser();
    document.querySelector("#website-url").value = "";
    setShowInput(false);
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestAddSiteAdvertiser = async (dataForm) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/site-user-advertiser",
        dataForm,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  return (
    <div className="py-2">
      <div class="alert alert-warning ">
        <p>
          <i class="fa fa-info pl-2"></i>توجه داشته باشید :{" "}
        </p>
        <ul class="pr-3">
          <li>
            <p>
              <span>آدرس سایت باید دارای </span>
              <span dir="ltr" className="px-1">
                http://
              </span>
              <span>یا</span>
              <span dir="ltr" className="px-1">
                https://
              </span>
              <span> و بدون حرف</span>
              <span className="px-1">/</span>
              <span>باشد </span>
              <span>به طور مثال : </span>
              <span>https://example.ir</span>
            </p>
          </li>
        </ul>
      </div>

      {messageTag}
      <div className="d-flex flex-column  flex-lg-row">
        <div
          className="btn btn-success"
          onClick={() => {
            setShowInput((prevState) => {
              return !prevState;
            });
          }}
        >
          <span className="pl-2">
            <i className="fa fa-plus"></i>
          </span>
          <span>اضافه کردن سایت تبلیغ دهنده</span>
        </div>
        <div
          className={` pt-2 pr-0 pt-lg-0 pr-lg-2 ${
            showInput == true ? "" : "d-none"
          } `}
        >
          <form
            onSubmit={(e) => {
              e.preventDefault();
              sendFrom();
            }}
            className="d-flex"
          >
            <div>
              <input
                dir="ltr"
                id="website-url"
                className="form-control"
                placeholder="https://example.ir"
                required
              />
            </div>
            <div className="pr-2">
              <button className="btn btn-success">درج</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
